import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { NAV } from "./data";
import { Logo, scrollToId, ease } from "./primitives";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 40);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  const go = (id) => { setOpen(false); scrollToId(id); };

  return (
    <motion.header
      initial={{ y: -80 }} animate={{ y: 0 }} transition={{ duration: 1, ease, delay: 0.2 }}
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color] duration-500 ${scrolled || open ? "border-b border-white/10 bg-[#060B19]/80 backdrop-blur-xl" : "border-b border-transparent"}`}
      data-testid="site-header"
    >
      <div className="mx-auto flex h-[72px] max-w-[1320px] items-center justify-between px-5 sm:px-8 lg:px-12">
        <button onClick={() => go("top")} className="flex items-center gap-3" data-testid="navbar-brand-logo">
          <Logo className="h-11 w-11" />
          <span className="font-display text-[15px] font-bold leading-[1.05] text-white text-left">Maicon<br />Roberto</span>
        </button>
        <nav className="hidden items-center gap-8 lg:flex">
          {NAV.map((n) => (
            <button key={n.id} onClick={() => go(n.id)} data-testid={`nav-link-${n.id}`}
              className="group relative text-sm font-medium text-slate-300 transition-colors hover:text-white">
              {n.label}
              <span className="absolute -bottom-1 left-0 h-px w-full origin-right scale-x-0 bg-[#CCFF00] transition-transform duration-500 group-hover:origin-left group-hover:scale-x-100" />
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button onClick={() => go("contato")} data-testid="navbar-cta-button"
            className="hidden rounded-full bg-[#CCFF00] px-5 py-2.5 text-sm font-bold text-[#060B19] transition-transform duration-300 hover:-translate-y-0.5 sm:inline-flex">
            Fale comigo
          </button>
          <button onClick={() => setOpen((o) => !o)} className="grid h-10 w-10 place-items-center rounded-full border border-white/20 text-white lg:hidden" data-testid="mobile-menu-toggle" aria-label="Menu">
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav initial={{ height: 0 }} animate={{ height: "auto" }} exit={{ height: 0 }} transition={{ duration: 0.5, ease }}
            className="overflow-hidden lg:hidden" data-testid="mobile-menu">
            <div className="flex flex-col gap-1 px-5 pb-6">
              {[...NAV, { id: "contato", label: "Contato" }].map((n) => (
                <button key={n.id} onClick={() => go(n.id)} data-testid={`mobile-nav-link-${n.id}`}
                  className="font-display border-b border-white/10 py-3 text-left text-2xl font-semibold text-white">
                  {n.label}
                </button>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
